import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Heart } from "lucide-react";
import { BRAND } from "../data/mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#3915AA] border-t border-white/10 pt-20 pb-8">
      <div className="container-custom grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-5">
            <img src={BRAND.logoWhiteUrl} alt="BarknFurs" data-testid="footer-logo" className="h-10 w-auto object-contain" />
            <div className="sr-only">
              <p className="font-heading font-bold text-xl text-white">BarknFurs</p>
              <p className="text-xs uppercase tracking-[0.2em] text-[#C9BCFF]">Grooming Studio</p>
            </div>
          </Link>
          <p className="text-white/60 text-sm leading-relaxed mb-5">
            Premium pet grooming in Bhubaneswar. Safe products, expert groomers, and a stress-free
            experience your pet will love.
          </p>
          <div className="flex gap-3">
            <a
              href={BRAND.social.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              className="p-2.5 rounded-full bg-white/5 border border-white/10 text-white/70 hover:text-[#FC5106] hover:border-[#FC5106]/40 transition"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={BRAND.social.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook-link"
              className="p-2.5 rounded-full bg-white/5 border border-white/10 text-white/70 hover:text-[#FC5106] hover:border-[#FC5106]/40 transition"
              aria-label="Facebook"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-heading text-white font-semibold mb-5 text-base">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["Home", "/"],
              ["Services", "/services"],
              ["Pricing", "/pricing"],
              ["Pet Shop", "/shop"],
              ["Track Order", "/track-order"],
              ["Gallery", "/gallery"],
              ["About Us", "/about"],
              ["Contact", "/contact"],
            ].map(([label, href]) => (
              <li key={href}>
                <Link
                  to={href}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-white/60 hover:text-[#FC5106] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-heading text-white font-semibold mb-5 text-base">Our Services</h4>
          <ul className="space-y-3 text-sm">
            {[
              "Dog Grooming",
              "Cat Grooming",
              "De-shedding & Dematting",
              "Dry Bath & Refresh",
              "Home Pet Grooming",
              "Plush Puppy Spa Treatment",
            ].map((s) => (
              <li key={s} className="text-white/60">
                {s}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-white font-semibold mb-5 text-base">Visit Us</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3 text-white/70">
              <MapPin className="w-4 h-4 text-[#FC5106] mt-0.5 flex-shrink-0" />
              <span>{BRAND.address}</span>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Phone className="w-4 h-4 text-[#FC5106] flex-shrink-0" />
              <a href={`tel:${BRAND.phoneRaw}`} data-testid="footer-phone-link" className="hover:text-white">
                {BRAND.phone}
              </a>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Mail className="w-4 h-4 text-[#FC5106] flex-shrink-0" />
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="hover:text-white">
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <Clock className="w-4 h-4 text-[#FC5106] mt-0.5 flex-shrink-0" />
              <span>{BRAND.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-custom mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3">
        <p className="text-xs text-white/60">© {year} BarknFurs Grooming Studio · All rights reserved.</p>
        <p className="text-xs text-white/60 flex items-center gap-1.5">
          Made with <Heart className="w-3 h-3 text-[#FC5106] fill-[#FC5106]" /> for pets in Bhubaneswar
        </p>
      </div>
    </footer>
  );
}
